import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../services/auth.service';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const urlRef = window.location.pathname;
  const initPath = `/${process.env.REACT_APP_PATH}`;

  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) => (
        // eslint-disable-next-line no-nested-ternary
        AuthService.isLogin()
          ? (AuthService.getCurrentRole() === 1 || AuthService.getCurrentRole() === 1
            // eslint-disable-next-line react/jsx-props-no-spreading
            ? <Component {...props} />
            : <Redirect to={`${initPath}private`} />)
          : <Redirect to={`${initPath}login?ref=${urlRef}`} />
      )}
    />
  );
};

export default PrivateRoute;
